/* eslint-disable max-classes-per-file */
import { i18n } from 'utils/i18n';
import { BaseError } from './baseErrors';

export class UserError extends BaseError {}

export class InvalidLoginOrPassword extends UserError {
  constructor() {
    super(i18n.t('errors:incorrect_login_or_password'));
  }
}

export class PasswordError extends UserError {}

export class NewPasswordRequired extends PasswordError {
  constructor(public data: Record<string, unknown>) {
    super(i18n.t('errors:password_change_required'));
  }
}

export class PasswordChangeRequired extends PasswordError {
  constructor() {
    super(i18n.t('errors:password_change_required'));
  }
}

export class InvalidConfirmationCode extends UserError {
  constructor() {
    super(i18n.t('errors:incorrect_confirmation_code'));
  }
}

export class UserIsBlocked extends UserError {
  constructor() {
    super(i18n.t('errors:user_blocked'));
  }
}
